import React from "react";
import { ReactComponent as ArrowUpIcon } from "../../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../../Icons/arrowDown.svg";

export default function Thread({ thread, isReusable, isShow, type }) {
  const firstThread = {
    width: "95%",
    minHeight: "44px",
    border: ` 1px solid #E0E2E6`,
    padding: "10px 12px 10px 12px",
    borderRadius: "8px",
    background: "#F6F7F8",
    color: "#2A364A",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "300",
    marginLeft: "5%",
    marginBlock: "5px",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const restThread = {
    width: "85%",
    minHeight: "44px",
    border: "1px solid #E0E2E6",
    padding: "10px 12px 10px 12px",
    borderRadius: "8px",
    background: "#FFFFFF",
    color: "#5C667B",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "300",
    marginLeft: "15%",
    marginBottom: "5px",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStylessss = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  // console.log(isReusable, thread);
  return (
    <>
      {type === "thread" && !isReusable && (
        <div>
          <div style={{ width: "100%" }}>
            {thread.map((item, index) => {
              return index === 0 ? (
                <div key={index} style={firstThread} dangerouslySetInnerHTML={{
                  __html:item,
                }}>
                </div>
              ) : (
                <div key={index} style={restThread} dangerouslySetInnerHTML={{
                  __html:item,
                }}>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {type === "thread" && isReusable && (
        <div>
          <div style={{ width: "100%" }}>
            <div style={firstThread} dangerouslySetInnerHTML={{
                  __html:thread[0],
                }}></div>
            <div style={firstThread} dangerouslySetInnerHTML={{
                  __html:thread[1],
                }}></div>
            {isShow &&
              thread.map((item, index) => {
                return index === 0 || index === 1 ? null : (
                  <div key={index} style={restThread} dangerouslySetInnerHTML={{
                    __html:item,
                  }}>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {isShow && type==='email' && (
        <div>
          <div style={{ width: "100%" }}>
            {thread.map((item, index) => {
              return index === 0 ? (
                <div key={index} style={restThread} dangerouslySetInnerHTML={{
                  __html:item,
                }}>
                </div>
              ) : (
                <div key={index} style={restThread} dangerouslySetInnerHTML={{
                  __html:item,
                }}>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
